module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAACCAYAAAAuPE4AAAAAHklEQVQYlWP8H236nwE/YESTHRD1TAQsHRyAgYEBACesBZIqkUbnAAAAAElFTkSuQmCC"